import { SimpleProductFragment } from '@/fo/api/magento';

import { MediaGallery } from '../types';

export const mediaGalleryMapper = (
  mediaGallery: SimpleProductFragment['mediaGallery']
): MediaGallery => {
  if (!mediaGallery) return [];

  const items = mediaGallery
    .filter((media) => !media?.disabled)
    .map((media) => {
      const isImage = media?.__typename === 'ProductImage';
      const roles = isImage ? media?.types || [] : [];

      return {
        id: media?.position || 0,
        src: media?.url || '',
        alt: media?.label || '',
        type: 'image' as const, // TODO: видео пока в работе, будет браться из другого атрибута товара
        roles
      };
    });

  const mainImageIndex = items.findIndex((item) =>
    item.roles?.includes('image')
  );
  if (mainImageIndex > 0) {
    const [main] = items.splice(mainImageIndex, 1);
    items.unshift(main);
  }

  return items;
};

export const expertImageMapper = (
  mediaGallery: SimpleProductFragment['mediaGallery']
): string | null | undefined => {
  if (!mediaGallery) return null;

  const expertImages = mediaGallery.find((media) => {
    const isImage = media?.__typename === 'ProductImage';
    const roles = isImage ? media?.types || [] : [];

    return isImage && roles.includes('expert_opinion_photo');
  });

  return expertImages ? expertImages?.url : null;
};
